import CommandActionForm_vue_vue_type_script_setup_true_lang_default from "./CommandActionForm.vue_vue_type_script_setup_true_lang.js";
//#region src/v2/features/command-palette/components/CommandActionForm.vue
var CommandActionForm_default = CommandActionForm_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { CommandActionForm_default as default };

//# sourceMappingURL=CommandActionForm.vue.js.map